import { environment } from '../environments/environment';
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeGB from '@angular/common/locales/en-GB';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ClarityModule } from '@clr/angular';

import { AppComponent } from './app.component';

import {
  CoreModule,
  UserService,
  HomeComponent,
  HelpComponent,
  LoginComponent,
  SignupComponent
} from '@app/core';

import { ProviderModule } from '@app/provider';
import { ServiceModule } from '@app/service';
import { CategoryModule } from '@app/category';
import { ArticleModule } from '@app/article';
import { UserModule } from '@app/user';
import { TrainingModule } from '@app/training';

registerLocaleData(localeGB);

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ClarityModule,
    CoreModule,
    ProviderModule,
    ServiceModule,
    CategoryModule,
    ArticleModule,
    UserModule,
    TrainingModule,
    HttpClientModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent },
      { path: 'help', component: HelpComponent },
      { path: 'login', component: LoginComponent },
      { path: 'signup', component: SignupComponent }
    ])
  ],
  providers: [  UserService, { provide: LOCALE_ID, useValue: 'en-GB'} ],
  declarations: [
    AppComponent
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/